module.exports = __webpack_public_path__ + "static/media/participles5_img.848bff7e.JPG";